export interface RegionInfo {
    name: string;
    formatPrice: (price?: string) => string | undefined;
    namePage: string;
    redDays: {
        showHoliday: boolean;
        showSunday: boolean;
        sundayNumber: number;
    };
}

export const regionInfos: RegionInfo[] = [
    {
        name: "sv-SE",
        formatPrice: (price?: string) =>
            price && price.replace(/[^0-9,.]/g, "").replace(",", "."), // Remove non-price characters, replace ',' with '.'
        namePage: "namepage-stm-se.svg",
        redDays: {
            showHoliday: true,
            showSunday: true,
            sundayNumber: 7,
        },
    },
    {
        name: "en-GB",
        formatPrice: (price?: string) => price && price.replace(/[^0-9.]/g, ""), // Remove non-price characters
        namePage: "namepage-stm-en.svg",
        redDays: {
            showHoliday: false,
            showSunday: false,
            sundayNumber: 7,
        },
    },
    {
        name: "de-DE",
        formatPrice: (price?: string) =>
            price && price.replace(/[^0-9,.]/g, "").replace(",", "."), // Remove non-price characters, replace ',' with '.'
        namePage: "namepage-stm-de.svg",
        redDays: {
            showHoliday: true,
            showSunday: true,
            sundayNumber: 7,
        },
    },
    {
        name: "en-IE",
        formatPrice: (price?: string) => price && price.replace(/[^0-9.]/g, ""), // Remove non-price characters
        namePage: "namepage-stm-en.svg",
        redDays: {
            showHoliday: false,
            showSunday: false,
            sundayNumber: 7,
        },
    },
    {
        name: "de-AT",
        formatPrice: (price?: string) =>
            price && price.replace(/[^0-9,.]/g, "").replace(",", "."), // Remove non-price characters, replace ',' with '.'
        namePage: "namepage-stm-de.svg",
        redDays: {
            showHoliday: true,
            showSunday: true,
            sundayNumber: 7,
        },
    },
    {
        name: "en-US",
        formatPrice: (price?: string) => price && price.replace(/[^0-9.]/g, ""), // Remove non-price characters
        namePage: "namepage-stm-en.svg",
        redDays: {
            showHoliday: false,
            showSunday: true,
            sundayNumber: 7,
        },
    },
    {
        name: "da-DK",
        formatPrice: (price?: string) =>
            price && price.replace(/[^0-9,.]/g, "").replace(",", "."), // Remove non-price characters, replace ',' with '.'
        namePage: "namepage-stm-en.svg",
        redDays: {
            showHoliday: false,
            showSunday: true,
            sundayNumber: 7,
        },
    },
    {
        name: "fi-FI",
        formatPrice: (price?: string) =>
            price && price.replace(/[^0-9,.]/g, "").replace(",", "."), // Remove non-price characters, replace ',' with '.'
        namePage: "namepage-stm-en.svg",
        redDays: {
            showHoliday: true,
            showSunday: true,
            sundayNumber: 7,
        },
    },
    {
        name: "fr-FR",
        formatPrice: (price?: string) => price && price.replace(/[^0-9.]/g, ""), // Remove non-price characters
        namePage: "namepage-stm-en.svg",
        redDays: {
            showHoliday: false,
            showSunday: false,
            sundayNumber: 7,
        },
    },
    {
        name: "nl-NL",
        formatPrice: (price?: string) => price && price.replace(/[^0-9.]/g, ""), // Remove non-price characters
        namePage: "namepage-stm-en.svg",
        redDays: {
            showHoliday: false,
            showSunday: false,
            sundayNumber: 7,
        },
    },
    {
        name: "it-IT",
        formatPrice: (price?: string) => price && price.replace(/[^0-9.]/g, ""), // Remove non-price characters
        namePage: "namepage-stm-en.svg",
        redDays: {
            showHoliday: false,
            showSunday: false,
            sundayNumber: 7,
        },
    },
    {
        name: "es-ES",
        formatPrice: (price?: string) => price && price.replace(/[^0-9.]/g, ""), // Remove non-price characters
        namePage: "namepage-stm-en.svg",
        redDays: {
            showHoliday: false,
            showSunday: false,
            sundayNumber: 7,
        },
    },
];
